// extracted by mini-css-extract-plugin
export default {"-large":"EeRHEgi5GFJ06kb13ugs","aiBGLight":"F31vkboirOf1mKBhsv00","aiText":"XRPktOrDb2AnaPZu46xQ","removeBg":"vumiXWHqWm3UE0S04fzg","replaceOption":"yfdTROBdJeSFowoSbM0U"};